// src/components/TermsOfService.jsx
import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../assets/images/unionIcon.svg';

const TermsOfService = () => {
    return (
        <Container className="py-5">
            <div className="mb-4">
                <Link to="/login" className="text-decoration-none">
                    ← Back to Login
                </Link>
            </div>

            <Card>
                <Card.Body className="p-4 p-md-5">
                    <div className="text-center mb-4">
                        <img
                            src={logo}
                            alt="KNOKO"
                            style={{maxWidth: '150px', height: 'auto'}}
                            className="mb-3"
                        />
                        <h1>Terms of Service</h1>
                    </div>

                    <div className="terms-content">
                        <section className="mb-4">
                            <h2>1. Acceptance of Terms</h2>
                            <p>
                                By accessing and using KNOKO.ai (the "Service"), you accept and agree to be bound by the
                                terms and provisions of this agreement. If you do not agree to these Terms of Service,
                                please do not use our Service.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>2. Description of Service</h2>
                            <p>
                                KNOKO.ai provides a web-based platform and related services (collectively, the "Service").
                                We reserve the right to modify, suspend, or discontinue the Service (or any part thereof)
                                at any time with or without notice.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>3. User Accounts</h2>
                            <p>
                                To access certain features of the Service, you must register for an account. You agree to:
                            </p>
                            <ul>
                                <li>Provide accurate, current, and complete information during registration</li>
                                <li>Maintain the security of your password and account</li>
                                <li>Promptly update your account information if it changes</li>
                                <li>Accept responsibility for all activities that occur under your account</li>
                                <li>Notify us immediately of any unauthorized use of your account</li>
                            </ul>
                            <p>
                                You may not use another person's account without permission. We reserve the right to
                                terminate accounts that violate these Terms.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>4. User Conduct</h2>
                            <p>You agree not to use the Service to:</p>
                            <ul>
                                <li>Violate any applicable laws or regulations</li>
                                <li>Infringe upon the rights of others, including intellectual property rights</li>
                                <li>Upload or transmit viruses, malware, or other malicious code</li>
                                <li>Attempt to gain unauthorized access to our systems or networks</li>
                                <li>Interfere with or disrupt the Service or servers</li>
                                <li>Harass, abuse, or harm other users</li>
                                <li>Impersonate any person or entity</li>
                                <li>Collect or store personal data about other users without consent</li>
                                <li>Use automated systems (bots, scrapers) without our permission</li>
                            </ul>
                        </section>

                        <section className="mb-4">
                            <h2>5. Intellectual Property</h2>
                            <p>
                                The Service and its original content, features, and functionality are owned by KNOKO.ai
                                and are protected by international copyright, trademark, patent, trade secret, and other
                                intellectual property laws.
                            </p>
                            <p>
                                You retain ownership of any content you submit to the Service. By submitting content, you
                                grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and
                                display that content in connection with operating and providing the Service.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>6. Privacy</h2>
                            <p>
                                Your use of the Service is also governed by our Privacy Policy. Please review our
                                <Link to="/privacy"> Privacy Policy</Link> to understand our practices regarding your
                                personal information.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>7. Termination</h2>
                            <p>
                                We reserve the right to terminate or suspend your account and access to the Service
                                immediately, without prior notice or liability, for any reason, including breach of
                                these Terms. Upon termination, your right to use the Service will cease immediately.
                            </p>
                            <p>
                                You may terminate your account at any time by contacting us. All provisions of these
                                Terms that by their nature should survive termination shall survive, including ownership
                                provisions, warranty disclaimers, and limitations of liability.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>8. Disclaimer of Warranties</h2>
                            <p>
                                THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF
                                ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF
                                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
                            </p>
                            <p>
                                We do not warrant that:
                            </p>
                            <ul>
                                <li>The Service will be uninterrupted, secure, or error-free</li>
                                <li>The results obtained from using the Service will be accurate or reliable</li>
                                <li>Any errors in the Service will be corrected</li>
                            </ul>
                        </section>

                        <section className="mb-4">
                            <h2>9. Limitation of Liability</h2>
                            <p>
                                TO THE MAXIMUM EXTENT PERMITTED BY LAW, KNOKO.AI SHALL NOT BE LIABLE FOR ANY INDIRECT,
                                INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR
                                REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL,
                                OR OTHER INTANGIBLE LOSSES, RESULTING FROM:
                            </p>
                            <ul>
                                <li>Your access to or use of (or inability to access or use) the Service</li>
                                <li>Any conduct or content of any third party on the Service</li>
                                <li>Any content obtained from the Service</li>
                                <li>Unauthorized access, use, or alteration of your transmissions or content</li>
                            </ul>
                        </section>

                        <section className="mb-4">
                            <h2>10. Indemnification</h2>
                            <p>
                                You agree to indemnify, defend, and hold harmless KNOKO.ai, its officers, directors,
                                employees, and agents from any claims, liabilities, damages, losses, and expenses,
                                including reasonable attorney's fees, arising out of or in any way connected with:
                            </p>
                            <ul>
                                <li>Your access to or use of the Service</li>
                                <li>Your violation of these Terms</li>
                                <li>Your violation of any rights of another party</li>
                            </ul>
                        </section>

                        <section className="mb-4">
                            <h2>11. Governing Law</h2>
                            <p>
                                These Terms shall be governed by and construed in accordance with the laws of the
                                jurisdiction in which KNOKO.ai operates, without regard to its conflict of law provisions.
                            </p>
                            <p>
                                Any disputes arising from these Terms or the Service shall be resolved through binding
                                arbitration in accordance with the applicable arbitration rules, except where prohibited
                                by law.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>12. Changes to Terms</h2>
                            <p>
                                We reserve the right to modify or replace these Terms at any time at our sole discretion.
                                If a revision is material, we will provide at least 30 days' notice prior to any new terms
                                taking effect.
                            </p>
                            <p>
                                By continuing to access or use our Service after revisions become effective, you agree to
                                be bound by the revised terms. If you do not agree to the new terms, you must stop using
                                the Service.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>13. Severability</h2>
                            <p>
                                If any provision of these Terms is held to be invalid or unenforceable, such provision
                                shall be struck and the remaining provisions shall remain in full force and effect.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>14. Entire Agreement</h2>
                            <p>
                                These Terms, together with our Privacy Policy, constitute the entire agreement between
                                you and KNOKO.ai regarding the Service and supersede all prior agreements and understandings.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>15. Contact Information</h2>
                            <p>
                                If you have any questions about these Terms, please contact us at:
                            </p>
                            <p>
                                <strong>KNOKO.ai</strong><br />
                                Email: legal@knoko.ai<br />
                                Website: <a href="https://knoko.ai" target="_blank" rel="noopener noreferrer">https://knoko.ai</a>
                            </p>
                        </section>

                        <section className="mb-4">
                            <p className="text-muted">
                                By using KNOKO.ai, you acknowledge that you have read, understood, and agree to be bound
                                by these Terms of Service.
                            </p>
                        </section>
                    </div>
                </Card.Body>
            </Card>

            <div className="text-center mt-4">
                <Link to="/login" className="btn btn-primary" style={{ borderRadius: '56px' }}>
                    Back to Login
                </Link>
            </div>
        </Container>
    );
};

export default TermsOfService;